import React from "react"
import PropTypes from "prop-types"
import Image from "../Image"
import styles from "./Grid.module.scss"
import BlockContentWrapper from "../blockContent"

const Grid = ({ node: { gridItems } }) => {
  if (!gridItems || gridItems.length <= 0) return null
  return (
    <div className={styles.grid}>
      {gridItems.map(({ title, text, image }, index) => (
        <div className={styles.gridItem} key={`grid-item-${index}`}>
          <Image image={image} width={800} alt={title} />
          <h4>{title}</h4>
          {text && <BlockContentWrapper blocks={text} />}
        </div>
      ))}
    </div>
  )
}

Grid.propTypes = {
  items: PropTypes.shape({
    title: PropTypes.string,
    text: PropTypes.oneOfType([
      PropTypes.arrayOf(PropTypes.object),
      PropTypes.string,
    ]),
    image: PropTypes.object,
  }),
}

export default Grid
